import dashboard from "./dashboard";

export const DASHBOARD_NAMESPACE = "dashboard";

export default dashboard;
